export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5511.69892122.jpg";